import * as React from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import {
    ExternalCreditData,
    createFilteredStub,
    getSubInfoGroupedByClient,
    getExternalDataColumns,
    getExternalDataColumnsGroupedByClient
} from '../../../../Model/ExternalData'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import ReactTable from 'react-table'

export interface IExternalDataCreditInfoItemsViewProps {
    creditInfoItems: Array<ExternalCreditData>
    headerText?: string
}

class ExternalDataCreditInfoItemsView extends React.Component<IExternalDataCreditInfoItemsViewProps> {

    constructor(props: IExternalDataCreditInfoItemsViewProps) {
        super(props)
    }

    ls = LocalizationStore.getInstance()

    render() {
        const { creditInfoItems, headerText } = this.props

        var stubs = createFilteredStub(creditInfoItems)

        return (
            <div
                className="external-data-credit-info-items-view"
            >
                <h6 className="getExternalData">{headerText}</h6>
                <Tabs
                    id={'extternalDataByPhone' + Math.random().toString()}
                    defaultActiveKey="allCreditsSky"
                    animation={false}
                >
                    <Tab
                        title={this.ls!.t('allCreditsSky')}
                        eventKey="allCreditsSky"
                    >
                        <ReactTable
                            data={stubs.stubAllCreditsSky}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('allCreditsMagnit')}
                        eventKey="allCreditsMagnit"
                    >
                        <ReactTable
                            data={stubs.stubAllCreditsMagnit}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('declinedSky')}
                        eventKey="declinedSky"
                    >
                        <ReactTable
                            data={stubs.stubDeclinedSky}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('declinedMagnit')}
                        eventKey="declinedSkyMagnit"
                    >
                        <ReactTable
                            data={stubs.stubDeclinedMagnit}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('acceptedSky')}
                        eventKey="acceptedSky"
                    >
                        <ReactTable
                            data={stubs.stubAcceptedSky}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('acceptedMagnit')}
                        eventKey="acceptedMagnit"
                    >
                        <ReactTable
                            data={stubs.stubAcceptedMagnit}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('closedSky')}
                        eventKey="closedSky"
                    >
                        <ReactTable
                            data={stubs.stubClosedSky}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('closedMagnit')}
                        eventKey="closedMagnit"

                    >
                        <ReactTable
                            data={stubs.stubClosedMagnit}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>

                    <Tab
                        title={this.ls!.t('fraudSky')}
                        eventKey="fraudSky"

                    >
                        <ReactTable
                            data={stubs.stubFraudSky}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>

                    <Tab
                        title={this.ls!.t('fraudMagnit')}
                        eventKey="fraudMagnit"

                    >
                        <ReactTable
                            data={stubs.stubFraudMagnit}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>

                    <Tab
                        title={this.ls!.t('borrowersSky')}
                        eventKey="borrowersSky"
                    >
                        <ReactTable
                            data={stubs.stubSortedByCreditorSky}
                            columns={getExternalDataColumnsGroupedByClient()}
                            SubComponent={getSubInfoGroupedByClient}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('borrowersMagnit')}
                        eventKey="borrowersMagnit"
                    >
                        <ReactTable
                            data={stubs.stubSortedByCreditorMagnit}
                            columns={getExternalDataColumnsGroupedByClient()}
                            SubComponent={getSubInfoGroupedByClient}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                    <Tab
                        title={this.ls!.t('standart')}
                        eventKey="standart"
                    >
                        <ReactTable
                            data={stubs.stubStandart}
                            columns={getExternalDataColumns()}
                            // SubComponent={getSubInfo}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            noDataText={this.ls.t('No data text')}
                            filterable={true}
                            previousText={this.ls.t('Previous')}
                            nextText={this.ls.t('Next')}
                            pageText={this.ls.t('Page')}
                            ofText={this.ls.t('of')}
                        />
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default ExternalDataCreditInfoItemsView


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataViews/ExternalDataCreditInfoItemsView.tsx